export default {
    currentUser: {},
    passedUser: false
}
